import {
  createSlice,
  createSelector,
  createAsyncThunk,
  createEntityAdapter
} from '@reduxjs/toolkit'
import type { RootState } from '../../store'
import { API_PATH } from '../../constants';
import { Scenario } from '../../Classes1';
import { http } from '../../utils/config';

const playerScenarioAdapter = createEntityAdapter<any>()

const initialState = playerScenarioAdapter.getInitialState()

// Thunk functions
export const fetchPlayerScenarios = createAsyncThunk('playerScenarios/fetchPlayerScenarios', async () => {
  try {

    const response = await http.get(API_PATH + "/scenario")

    return response.data
  } catch (error: any) {
    if (error.response && error.response.data.message) {
      return error.response.data.message
    } else {
      return error.message
    }
  }
})

export const fetchTagScenarios = createAsyncThunk('playerScenarios/fetchTagScenarios', async ({ locationTags, topicTags, detailsTags, searchString }: { locationTags: string[], topicTags: string[], detailsTags: string[], searchString: string }, { rejectWithValue }) => {
  try {
      const response = await http.post(API_PATH + '/scenario', { locationTags: locationTags, topicTags: topicTags, detailsTags: detailsTags, searchString: searchString });
      return response.data
  } catch (error: any) {
    if (error.response && error.response.data.message) {
      return error.response.data.message
    } else {
      return error.message
    }
  }
})

const playerScenarioSlice = createSlice({
    name: 'playerScenarios',
    initialState,
    reducers: {
      playerScenarioToggled(state, action) {
        //const scenarioId = action.payload
      },
    },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPlayerScenarios.fulfilled, (state, action) => {
        playerScenarioAdapter.setAll(state, action.payload)

      })
  }
})

export const {
  playerScenarioToggled
} = playerScenarioSlice.actions

export default playerScenarioSlice.reducer

export const {
  selectAll: selectPlayerScenarios
} = playerScenarioAdapter.getSelectors((state: RootState) => state.playerScenarios)

export const updateScenario = createAsyncThunk(
  'playerScenarios/updateScenario',
  async (text: Scenario, { rejectWithValue }) => {
    try {
      
      const response = await http.put(API_PATH + '/scenario/' + text.id + '/info', { 'info': text });
      return response.status
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)

export const createScenario = createAsyncThunk(
  'playerScenarios/createScenario',
  async (text: Scenario, { rejectWithValue }) => {
    try {

      let response: any = {}
      response = await http.post(API_PATH + '/scenario/new', { info: text });
      let respObj: any = {};
      respObj.status = response.status;
      respObj.scenario = response.data;
      return respObj
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)

export const fetchImages = createAsyncThunk(
    'playerScenarios/fetchImages',
    async (id: string, { rejectWithValue }) => {
      try {
        
        const response = await http.get(API_PATH + '/scenario/' + id + '/images');
        return response.status
      } catch (error: any) {
        if (error.response && error.response.data.message) {
          return rejectWithValue(error.response.data.message)
        } else {
          return rejectWithValue(error.message)
        }
      }
    }
  )

export const selectPlayerScenariosSlice = createSelector(
  selectPlayerScenarios,
  (playerScenarios: Scenario[]) => { 
    return playerScenarios.map((playerScenario: Scenario) => {
      return playerScenario;
    })
  }
)
